import React from "react";
import style from "./index.module.scss";
import { ExerciseQuestionItem } from "../../../../../../service/question";
import { htmlToPlain, replaceImgTag } from "../../../../../../utils/common";

export default function ExerciseListItem({
    data,
    index
}: {
    data: ExerciseQuestionItem;
    index: number;
}) {
    return (
        <div className={style.root}>
            <div className={style.title}>
                {index}. <span className={style.info}>{data.queTypeName}</span>
            </div>

            <div className={style.content}>
                {htmlToPlain(data.contentText, replaceImgTag)}
            </div>
        </div>
    );
}
